import React, { useEffect, useState } from "react";
import { deleteIDP, getIDPList } from "../../api/IDP";
import { useSelector } from "react-redux";
import { failed, success } from "../../common/Toastify";
import Table from "react-bootstrap/Table";
import { Skeleton, TableCell, Tooltip } from "@mui/material";
import moment from "moment";
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import { Link, useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import EditIcon from "../../../assets/images/edit.png";
import DeleteIcon from "../../../assets/images/delete.png";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";

function IDPList() {
  const [IDPList, setIDPList] = useState([]);
  const { getConfirmation } = useConfirmDialog();

  const orgId = useSelector(
    (state) => state?.auth?.user?.organizations?.[0]?.id
  );
  const userRoles = useSelector(
    (state) => state?.auth?.user?.["cognito:groups"]
  );
  const isAdmin = userRoles?.includes("Super-Admin");

  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const totalRows = IDPList?.length;
  const navigate = useNavigate();
  const fetchIDPList = () => {
    setIsLoading(true);
    getIDPList(orgId)
      .then((res) => {
        if (res?.status === true) {
          setIDPList(res?.identityProviders);
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchIDPList();
  }, []);

  const handleDeleteClick = async (providerName) => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      providerName,
      actionBtnTitle: "Delete",
      message: `Are you sure you would like to delete ${providerName}?`,
    });
    if (confirmed) {
      setIsLoading(true);
      deleteIDP(providerName, orgId)
        .then((res) => {
          if (res?.status === true) {
            success(res?.message || "SAML config deleted successfully");
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
        })
        .finally(() => {
          fetchIDPList();
        });
    }
  };

  return (
    <section className="common-listing">
      <div className="heading-wrap h-change">
        <div className="heading-wrap mb-3">
          <Tooltip title="Go back">
            <div
              style={{ marginRight: "1rem", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              <ArrowBack />
            </div>
          </Tooltip>
        </div>
        {(isAdmin || IDPList?.length === 0) && (
          <div className="right-wrap" style={{ margin: "left" }}>
            <Link
              variant="primary"
              to="/app/create-idp"
              className="custom-btn"
              title="Create IDP Config"
              style={{ width: "auto" }}
            >
              {" "}
              + Create IDP{" "}
            </Link>
          </div>
        )}
      </div>
      <div className="table-wrap">
        <Table responsive>
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>CreatedAt</th>
              <th>Updated At</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              [1, 2, 3, 4]?.map((val) => (
                <tr key={val}>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                </tr>
              ))
            ) : IDPList?.length > 0 ? (
              IDPList?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )?.map((data) => {
                return (
                  <tr key={data?.ProviderName}>
                    <td className="name-text">{data?.ProviderName}</td>
                    <td>
                      {moment(data?.CreationDate)
                        .utc()
                        .format("YYYY-MM-DDTHH:mm:ss")}
                    </td>
                    <td>
                      {moment(data?.LastModifiedDate)
                        .utc()
                        .format("YYYY-MM-DDTHH:mm:ss")}
                    </td>
                    <td>
                      <div className="action-wrap">
                        <Tooltip title={"Edit"}>
                          <Link
                            to={`/app/update-idp?providerName=${data?.ProviderName}`}
                            variant="primary"
                            className="success-btn"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </Link>
                        </Tooltip>

                        <Tooltip title={"Delete"}>
                          <Link
                            to=""
                            variant="primary"
                            onClick={() =>
                              handleDeleteClick(data?.ProviderName)
                            }
                            className="delete-btn"
                            style={{ opacity: "1" }}
                          >
                            <img src={DeleteIcon} alt="Delete" />
                          </Link>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <TableCell colSpan="5" style={{ textAlign: "center" }}>
                  No Data Available
                </TableCell>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {IDPList?.length > 0 ? (
        <CustomPagination
          tableData={IDPList}
          totalRows={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          handlePage={(pageNo) => setPage(pageNo)}
        />
      ) : null}
    </section>
  );
}

export default IDPList;
